export interface ICareerOffer {
  title: string;
  description: string;
  color: string;
}
export const offers: readonly ICareerOffer[] = [
  {
    title: 'Гибкая удалёнка',
    description:
      'У большинства команд нет обязательных офисных дней. Но если хочется офлайна, есть три офиса в Москве, Санкт-Петербурге, Новосибирске. В каждом — удобные переговорные, зоны отдыха с массажными девайсами и PlayStation, а также кофе, сэндвичи и фрукты.',
    color: 'is-blue',
  },
  {
    title: 'Среда для роста',
    description:
      'Мы не ограничиваемся формальными тренингами. У нас есть доступ к профильным конференциям, библиотекам знаний и программе менторства. Определяй вектор обучения, мы предоставим для этого ресурсы.',
    color: 'is-orange',
  },
  {
    title: 'ДМС с первого дня',
    description:
      'Никакого испытательного срока для твоего здоровья. Доступ к лучшим клиникам и врачам — с первого рабочего дня.',
    color: 'is-orange is-reverse-mobile',
  },
  {
    title: 'Персональный пакет льгот',
    description:
      'Мы понимаем, что потребности у всех разные. Раз в год открываем денежный депозит на 25 тысяч рублей, и только ты решаешь, на что его потратить: оплатить фитнес, купить билеты, сделать приятные покупки для себя и близких или заняться благотворительностью.',
    color: 'is-blue is-reverse-mobile',
  },
  {
    title: 'Дни «вне зоны доступа»',
    description:
      'Помимо основного отпуска, мы даём 5 дополнительных дней в году. Используй их, чтобы просто выдохнуть, заняться личными делами или съездить в короткое путешествие — без необходимости обосновывать причину и брать отгулы за свой счёт.',
    color: 'is-blue',
  },
  {
    title: 'Восстановление без потерь',
    description:
      'Болеть неприятно, а терять из-за этого в деньгах — тем более. Мы доплачиваем до 100% твоего оклада за 10 дней больничного в год. Просто поправляйся и не думай о вычетах из зарплаты.',
    color: 'is-orange',
  },
  {
    title: 'Бонусы вне офиса',
    description:
      'BestBenefits, бонусы от банков-партнёров и другие партнёрские предложения — скидки на спорт, онлайн-сервисы, технику, кино и товары для дома. Помогаем делать повседневные покупки чуть выгоднее и приятнее.',
    color: 'is-orange is-reverse-mobile',
  },
  {
    title: 'Бонусы на продвижение',
    description:
      'Продаёшь квартиру, сдаёшь комнату или просто ищешь жильё для себя или близких? Дарим сотрудникам бонусы на размещение и продвижение объявлений на Циане. Знание продукта изнутри плюс приятный бонус снаружи.',
    color: 'is-blue is-reverse-mobile',
  },
  {
    title: 'День без созвонов',
    description:
      'Официально среда в Циане — день без встреч. Это время мы оставляем для задач, требующих концентрации без постоянных переключений между звонками. Встречи в этот день возможны, но только если без них действительно не обойтись.',
    color: 'is-blue',
  },
  {
    title: 'Карьера',
    description:
      'В Циане нет единого карьерного маршрута. Можно расти в экспертизе или вертикально, брать больше ответственности и расширять влияние. Мы даём возможности и поддержку, чтобы каждый развивался в своём темпе и направлении.',
    color: 'is-orange',
  },
];
